export default {
	showRejectCompanyApplication: false,
	showSendScoutMailModel: false,
	projectList:[],
	projectId:[],
}
